import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface PvUnit {
  kwp: number,
  commissioning: string
}

export interface AdditionalConsumptionPointInKwh {
  pvLocationPostalCode : string,
  consumptionHouseInKwh : string
}

export interface PackageProposalCloud4DataState {
  pvUnits: PvUnit
  additionalConsumptionPointInKwh: AdditionalConsumptionPointInKwh
  batterySizesInKwh: string[]
  pvLocationPostalCode: string
  senecSystemId: string
  consumptionHouseInKwh: number
  heatSeparateMeter: boolean
  heatPowerConsumption: number
  ctgMileagePerYear: number
  ctgConsumptionInKwhPerHundred: number
  ctgPercentageChargedAtHome: number
  totalFeedInInkwh: number
}

export const initialStatePvUnits: PvUnit = {
  kwp: 10,
  commissioning: '2024-01-01'
}

export const initialStateAdditionalConsumptionPoint: AdditionalConsumptionPointInKwh = {
  pvLocationPostalCode: '91220',
  consumptionHouseInKwh: '56000'
}

export const initialState: PackageProposalCloud4DataState = {
  pvUnits: initialStatePvUnits,
  additionalConsumptionPointInKwh: initialStateAdditionalConsumptionPoint,
  batterySizesInKwh: ['10', '7.5'],
  pvLocationPostalCode: '04129',
  senecSystemId: '1040004',
  consumptionHouseInKwh: 5600,
  heatSeparateMeter: false,
  heatPowerConsumption: 1500,
  ctgMileagePerYear: 1500,
  ctgConsumptionInKwhPerHundred: 1500,
  ctgPercentageChargedAtHome: 15,
  totalFeedInInkwh: 1500
}

const packageProposalDataCloud4Slice = createSlice({
  name: '/cloud4/query/contract',
  initialState,
  reducers: {
    setPackageProposalDataCloud4Slice: (
      state,
      action: PayloadAction<PackageProposalCloud4DataState>
    ) => {
      return action.payload
    }
  }
})

export const { setPackageProposalDataCloud4Slice } = packageProposalDataCloud4Slice.actions

export default packageProposalDataCloud4Slice.reducer
